module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/quote-6f04f4d842f44354664164801e5709dd.svg";